import { ISocialBase, ISocialVerified } from '@/interfaces/socials'
import { ConnectionRequestType, UserPreferences } from '@/interfaces/user'
import { SubscriptionProductNames } from '@/interfaces/subscription'
import { Project } from 'containers/projects/types/project'

export interface User {
  // ----------------------------------------
  // ID
  // ----------------------------------------
  id?: string
  auth0Id?: string
  auth0Ids?: string[]
  stripeIds?: string[]

  // ----------------------------------------
  // Properties (in alphabetical order)
  // ----------------------------------------
  about?: string
  authorized?: boolean
  avatar?: string
  beehiivSubId?: string
  blockedUsers?: string[]
  collabInterest?: string[]
  connections?: string[]
  connectionsReceived?: ConnectionRequestType
  connectionsSent?: ConnectionRequestType
  contentType?: string[]
  converImage?: string // TODO: this will be deleted
  coverImage?: string
  creatorType?: string[]
  dateOfBirth?: Date
  email?: string
  ethnicity?: string
  firstName?: string
  gender?: string
  invitationsSent?: string[]
  is_complete?: boolean
  lastName?: string
  location?: string
  newUser?: boolean
  phone?: string
  preferences?: UserPreferences
  projects?: Project[]
  referredUserIDs?: string[]
  referringUserID?: string
  signupStep?: number
  socials?: ISocialBase[]
  subscriptions?: Record<SubscriptionProductNames, boolean>
  subscribed?: boolean
  title?: string
  totalAudience?: number
  totalVerifiedAudience?: number
  username?: string
  usernameLower?: string
  verifiedSocials?: ISocialVerified

  // ----------------------------------------
  // New Properties
  // ----------------------------------------
  externalLink?: {
    linkText: string
    url: string
  }
  isHiring?: boolean
  isEmployer?: {
    companyName: string
    companyWebsite: string
  }
  timestamp?: number
}

export interface UserStore {
  user?: User
  setUser: (user: User) => void
}

export enum UserQueryKeys {
  USER = 'user',
  INVITATIONS = 'invitations',
  NEW_CONNECTIONS = 'new_connections',
  FRIEND_INVITATIONS = 'friend_invitations',
  CONNECTIONS = 'connections',
}
